<template>
    <div>
        <template>
            <div class="text-center">
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="#fff" dark v-bind="attrs" v-on="on" small
                            style="background-color: rgba(255, 255, 255, 0.15);text-transform: none;">
                            <v-icon small class="mdi mdi-account" />
                            <span class="ml-2 d-none d-sm-inline-flex">{{ username }}</span>
                        </v-btn>
                    </template>

                    <v-card>
                        <v-list>
                            <v-list-item>
                                <v-list-item-avatar>
                                    <img src="@/styles/assets/account_frofile.png" alt="John">
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title>{{ username }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
                                </v-list-item-content>

                            </v-list-item>
                        </v-list>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <TextButtonBlock :buttonText="$store.getters.t('Logout')" @click="submitLogout" :width="'100%'" isPrimary :loading="loading"/>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>
        </template>
    </div>
</template>

<script>
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import { mapActions, mapGetters } from 'vuex';


export default {
    components: {
        TextButtonBlock
    },
    data() {
        return {
            menu: false,
            loading: false,
        };
    },
    computed: {
        ...mapGetters('user', ['email']),
        ...mapGetters('user', ['username']),
    },
    methods: {
        ...mapActions('user', ['logout']),
        submitLogout() {
            this.loading = true;
            this.logout()
                .then(() => {
                    // this.$router.push({ path: '/' });
                    if (this.$route.path !== '/') {
                        this.$router.push('/').catch(err => {
                        if (err.name !== 'NavigationDuplicated') throw err;
                        });
                    }
                })
                .catch(error => {
                    console.error('Logout error:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    }
}
</script>